import styled from 'styled-components';
import { BaseAvatar } from './BaseAvatar';
import COLORS from 'constants/colors';

const StyledAvatar = styled(BaseAvatar)`
  background-color: ${COLORS.WHITE};
  border: 1px solid ${COLORS.BLACK}1A;
`;

interface ClientAvatarProps {
  logo?: string | null;
  clientName: string;
}

export const ClientAvatar = ({ logo, clientName }: ClientAvatarProps) => {
  if (logo) {
    return (
      <StyledAvatar>
        <img src={logo} alt="Client logo" />
      </StyledAvatar>
    );
  }
  // Letter avatar fallback
  return <BaseAvatar>{clientName[0]?.toUpperCase() || '?'}</BaseAvatar>;
};
